import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useGame } from '../context/GameContext';
import { NoirBackground, Button } from '../components/GameUI';
import { User, VenetianMask, Ghost, X } from 'lucide-react';
import { checkWinCondition } from '../utils/gameLogic';
import { playWrongBuzzer, playCorrectDing } from '../utils/sounds';

const Elimination = () => {
  const { eliminatedPlayer, players, setGameState, setWinner, round, setRound } = useGame();
  const [step, setStep] = useState('reveal');

  useEffect(() => { if (step === 'reveal') { const t = setTimeout(() => setStep('role'), 1500); return () => clearTimeout(t); } }, [step]);
  useEffect(() => {
    if (step === 'role') {
      if (eliminatedPlayer.role === 'civilian') playWrongBuzzer(); else playCorrectDing();
      const w = checkWinCondition(players);
      if (w) { const t = setTimeout(() => { setWinner(w); setGameState('results'); }, 3000); return () => clearTimeout(t); }
    }
  }, [step, players, setWinner, setGameState, eliminatedPlayer]);

  const cont = () => {
    if (eliminatedPlayer.role === 'mrwhite') { setGameState('mrWhiteGuess'); return; }
    const w = checkWinCondition(players);
    if (w) { setWinner(w); setGameState('results'); } else { setRound(round + 1); setGameState('gameRound'); }
  };

  const c = (r) => r === 'civilian' ? '#E0DDD5' : r === 'imposter' ? '#EF4444' : '#FFFFFF';
  const ic = (r) => r === 'civilian' ? <User size={48} strokeWidth={1.5} /> : r === 'imposter' ? <VenetianMask size={48} strokeWidth={1.5} /> : <Ghost size={48} strokeWidth={1.5} />;
  const l = (r) => r === 'civilian' ? 'Civilian' : r === 'imposter' ? 'Imposter' : 'Mr. White';

  if (step === 'reveal') {
    return (
      <div className="min-h-dvh flex flex-col items-center justify-center p-6 relative select-none">
        <NoirBackground />
        <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}
          className="text-center space-y-6 relative z-10">
          <X size={64} className="mx-auto text-[#EF4444]" strokeWidth={3} />
          <div className="red-line w-16 mx-auto" />
          <h1 className="font-typewriter text-5xl text-[#E0DDD5]">{eliminatedPlayer.name}</h1>
          <div className="font-mono text-[#5A5A5A] text-sm uppercase tracking-[0.2em]">has been eliminated</div>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center p-6 relative select-none">
      <NoirBackground />
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="w-full max-w-md space-y-8 relative z-10">
        <div className="text-center space-y-4">
          <div className="font-mono text-[#5A5A5A] text-xs uppercase tracking-[0.3em]">{eliminatedPlayer.name} was</div>
          <div className="red-line w-12 mx-auto" />
          <motion.div className="flex justify-center" style={{ color: c(eliminatedPlayer.role) }}
            initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: 'spring', delay: 0.1 }}>
            {ic(eliminatedPlayer.role)}
          </motion.div>
          <motion.h1 className="font-typewriter text-6xl" style={{ color: c(eliminatedPlayer.role) }}
            initial={{ scale: 0.5, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', delay: 0.2 }}>
            {l(eliminatedPlayer.role)}
          </motion.h1>
        </div>
        {!checkWinCondition(players) && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}>
            <Button data-testid="continue-after-elimination-btn" color="red" onClick={cont}>Continue Investigation</Button>
          </motion.div>
        )}
        {checkWinCondition(players) && (
          <div className="text-center font-mono text-[#5A5A5A] text-sm animate-pulse uppercase tracking-wider">Closing case...</div>
        )}
      </motion.div>
    </div>
  );
};

export default Elimination;
